import { call, put, fork } from 'redux-saga/effects'
import _ from 'lodash'
import firebase from '../config/firebase'
import DriverSegmentActions from '../reducers/driverSegmentReducer'

export function* syncDriverSegments() {
  const dbRef = firebase.firestore().collection('driver_segments')
  try {
    const querySnapshot = yield call([dbRef, dbRef.get])
    const driverSegments = {}
    yield put(DriverSegmentActions.setDriverSegmentLoading(true))
    querySnapshot.forEach(driverSegment => {
      driverSegments[driverSegment.id] = { ...driverSegment.data(), id: driverSegment.id }
    })
    yield put(DriverSegmentActions.setDriverSegmentLoading(false))
    yield put(DriverSegmentActions.setDriverSegments(driverSegments))
  } catch (error) {
    yield put(DriverSegmentActions.setDriverSegmentLoading(false))
    alert(error)
  }
}

export function* saveDriverSegment({ data, callBack }) {
  const driverSegmentCollection = firebase.firestore()
                  .collection('driver_segments')

  const driverSegmentDoc = data.id === "" ? driverSegmentCollection.doc() : driverSegmentCollection.doc(data.id)
  const { id } = driverSegmentDoc

  // eslint-disable-next-line no-param-reassign
  data.id = id

  try {
    yield put(DriverSegmentActions.setDriverSegmentAdding(true))
    yield call([driverSegmentDoc, driverSegmentDoc.set], data)
    yield put(DriverSegmentActions.setDriverSegment(id, data))
    yield put(DriverSegmentActions.setDriverSegmentAdding(false))
    yield call(callBack)
  } catch (e) {
    alert(e)
    yield put(DriverSegmentActions.setDriverSegmentAdding(false))
  }
}

export function* deleteDriverSegment({ id, drivers }) {
  const dbRef = firebase.firestore().collection('driver_segments').doc(id)
  const driverRef = firebase.database().ref()
  const driverObj = {}

  try {
    _.map(drivers, (driver) => {
      driverObj[`deliverers/${driver.driverUID}/driver_segment`] = ''
    })

    yield fork([dbRef, dbRef.delete])
    yield call([driverRef, driverRef.update], driverObj)
  } catch (error) {
    alert(error)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/driverSegmentSaga.js